// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"35":"85d7bc83","293":"component---src-pages-index-js","563":"cb355538"}[chunkId] || chunkId) + "-" + {"35":"9a8f24ffd7ccfd1f366a","293":"ce6d2829701761f7e77c","452":"4fa8a5b01f70c4056bea","522":"a4c4b596ebcc7fb45194","551":"f2be10a379c7f146dcae","563":"80c47eae6205a2149519"}[chunkId] + ".js";
};